// frontend/src/api/staff.ts
import api from './axios';
import {
    Staff,
    CreateStaffRequest,
    UpdateStaffRequest
} from '../types/staff';

export async function getStaff(): Promise<Staff[]> {
    const res = await api.get<Staff[]>('/staff');
    return res.data;
}

export async function getOneStaff(id: string): Promise<Staff> {
    const res = await api.get<Staff>(`/staff/${id}`);
    return res.data;
}

export async function createStaff(
    data: CreateStaffRequest
): Promise<Staff> {
    const res = await api.post<Staff>('/staff', data);
    return res.data;
}

export async function updateStaff(
    id: string,
    data: UpdateStaffRequest
): Promise<Staff> {
    const res = await api.patch<Staff>(`/staff/${id}`, data);
    return res.data;
}

export async function deleteStaff(id: string): Promise<void> {
    await api.delete(`/staff/${id}`);
}
